var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolunteersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00033,
    cy: 3.66536,
    r: 2.33333,
    stroke: "#214ba5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 13.6654C1.33301 10.7198 4.0193 8.33203 7.33301 8.33203",
    stroke: "#214ba5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6163 9.33203C9.90758 9.33203 9.33301 10.0016 9.33301 10.8275C9.33301 12.3229 10.8497 13.6825 11.6663 13.9987C12.483 13.6825 13.9997 12.3229 13.9997 10.8275C13.9997 10.0016 13.4251 9.33203 12.7163 9.33203C12.2823 9.33203 11.8986 9.58312 11.6663 9.96744C11.4341 9.58312 11.0504 9.33203 10.6163 9.33203Z",
    stroke: "#214ba5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteersIcon);
export default __webpack_public_path__ + "static/media/volunteers-icon.31356639e59fec0d324432f275f3911d.svg";
export { ForwardRef as ReactComponent };